import apiClient from './api';

// This function should be called after the Auth0 authentication is completed
export const saveUserProfile = async (userId, profileData) => {
  return apiClient.patch(`/api/users/${userId}`, {
    ...profileData,
    user_id: userId,
  });
};

export const fetchUserProfile = async (userId) => {
  return apiClient.get(`/api/users/profile/${userId}`);
};

export const updateUserProfile = async (userId, profileData) => {
  return apiClient.patch(`/api/users/${userId}`, profileData);
};

export const verifyEmail = async (email) => {
  return apiClient.post('/api/verification/resend-verification-email', {
    email
  });
};

export const saveUserLocation = async (locationData) => {
  return apiClient.post('/api/retailerlocations', locationData);
};

export const fetchUserLocations = async () => {
  return apiClient.get('/api/retailerlocations');
};

// Store reference to Auth0's getAccessTokenSilently function
let getAccessTokenSilentlyFn = null;

// Store reference to Auth0's logout function
let logoutFn = null;

// Call this from your App component after Auth0Provider initializes
export const setAuthTokenGetter = (getAccessTokenSilently) => {
  getAccessTokenSilentlyFn = getAccessTokenSilently;
};

// Call this to set the logout function reference
export const setLogoutHandler = (logout) => {
  logoutFn = logout;
};

// Trigger logout (used by API interceptor on 401)
export const triggerLogout = () => {
  if (logoutFn) {
    logoutFn({ logoutParams: { returnTo: window.location.origin } });
  } else {
    // Fallback: clear storage and redirect to home
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }
};

// Helper function to get the Auth0 token - used by the API client
export const getToken = async () => {
  if (!getAccessTokenSilentlyFn) {
    console.warn('Auth token getter not initialized yet');
    return null;
  }

  try {
    return await getAccessTokenSilentlyFn();
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

// This function would be used to update the apiClient interceptor
export const setupAuthInterceptor = () => {
  apiClient.interceptors.request.use(async (config) => {
    try {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  });
};